import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_PREFIX } from "../../config/env";
import { getAuthToken, clearAuthSession } from "../../services/storage";

export default function AutoLogoutHandler() {
  const navigate = useNavigate();
  const lastActivityRef = useRef(Date.now());

  useEffect(() => {
    const token = getAuthToken();
    if (!token) return;

    // Fetch latest auto-logout settings from backend
    axios
      .get(`${API_PREFIX}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.data?.data) {
          const { autoLogoutEnabled, autoLogoutMinutes } = res.data.data;
          localStorage.setItem("autoLogoutEnabled", JSON.stringify(Boolean(autoLogoutEnabled)));
          localStorage.setItem("autoLogoutMinutes", String(autoLogoutMinutes || 15));
        }
      })
      .catch((err) => {
        console.warn("Could not sync auto-logout settings:", err);
      });

    const resetActivity = () => {
      lastActivityRef.current = Date.now();
    };

    const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"];
    events.forEach((evt) => window.addEventListener(evt, resetActivity, { passive: true }));

    const interval = setInterval(() => {
      const currentToken = getAuthToken();
      if (!currentToken) return;

      const enabledStr = localStorage.getItem("autoLogoutEnabled");
      const minutesStr = localStorage.getItem("autoLogoutMinutes");

      const isEnabled = enabledStr ? JSON.parse(enabledStr) : false;
      const timeoutMinutes = minutesStr ? Math.max(1, parseInt(minutesStr, 10) || 15) : 15;

      if (isEnabled) {
        const idleSeconds = (Date.now() - lastActivityRef.current) / 1000;
        const maxIdleSeconds = timeoutMinutes * 60;

        if (idleSeconds >= maxIdleSeconds) {
          console.warn(`[AutoLogout] Idle for ${idleSeconds}s (Max: ${maxIdleSeconds}s). Logging out...`);
          clearAuthSession();
          navigate("/login", {
            state: { sessionExpired: true, reason: "inactivity" },
            replace: true,
          });
        }
      }
    }, 5000);

    return () => {
      events.forEach((evt) => window.removeEventListener(evt, resetActivity));
      clearInterval(interval);
    };
  }, [navigate]);

  return null;
}
